import {ChangeDetectionStrategy, Component, inject, OnInit, ViewEncapsulation} from '@angular/core';
import {AppConfigService} from '../../services/app-config.service';
import {LoaderService} from '../../services/loader.service';
import {TraceMethod} from '@sentry/angular';

@Component({
  standalone: false,
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterComponent implements OnInit {
  public year = new Date().getFullYear();
  private appConfigService = inject(AppConfigService);
  public logoUrl = `${this.appConfigService.appConfig.amazonS3Url}assets/varden-logo-nocross.webp`;
  private loader = inject(LoaderService);
  public loadingItem = this.loader.loadingItem;

  @TraceMethod()
  ngOnInit() {}

  public renewConsent(event: Event): void {
    event.preventDefault();
    window.Cookiebot?.renew();
  }
}
